import React, { Component } from 'react';

export default class TemplateOne extends Component {
  constructor(props) {
    super(props);
    this.showMyTemplate = props.showMyTemplate;
  }
  render() {
    return (
      <div className="row" style={{ marginBottom: 30 }}>
        <div className="col-lg-7 headline">
          <h2 style={{ lineHeight: '130%', marginTop: 30 }}>
            <strong>HAPI</strong>
            <br />
            <small>Web and services application framework</small>
            <br />
            {this.showMyTemplate ? 'No! Take it away!' : 'Yes! Please!'}
            <small>This is Template one</small>
          </h2>
        </div>
      </div>
    );
  }
}
